export const CLIENT_GROUP_TABLE = "client-groups"
export const CLIENT_GROUP_TABLE_SCHEMA = "id, companyId, syncId"
